
import { PaymentInfo } from '@/hooks/useCourierPayments';

// Функция для получения URL оплаты на основе номера платежа с добавлением параметра редиректа
export const getPaymentUrl = (paymentNumber: string | undefined, redirectUrl?: string) => {
  if (!paymentNumber) {
    console.warn('Получение URL платежа: номер платежа не указан');
    return '';
  }
  
  let url = `https://sp1-nova.ru/api/pay/?subdomain=tuktukrent.amocrm.ru&invoice_id=${paymentNumber}`;
  
  // Добавляем параметр return_url если он указан
  if (redirectUrl) {
    url += `&return_url=${encodeURIComponent(redirectUrl)}`;
  }
  
  console.log('Сформирован URL платежа:', url);
  return url;
};

/**
 * Хук для фильтрации ожидающих платежей и платежей с типом 'auth'
 * Показывает платежи, которые нужно оплатить или авторизовать
 */
export const usePendingPayments = (payments: PaymentInfo[] = []): {
  pendingPayments: PaymentInfo[],
  authPayment: PaymentInfo | null
} => {
  console.log('usePendingPayments: получено платежей:', payments?.length || 0);
  
  if (!payments || payments.length === 0) {
    console.log('usePendingPayments: нет платежей для обработки');
    return { pendingPayments: [], authPayment: null };
  }
  
  // Находим платежи со статусом 'pending'
  const pendingPayments = payments.filter(p => p.status === 'pending');
  console.log('usePendingPayments: найдено платежей pending:', pendingPayments.length);
  
  // Находим последний платеж со статусом 'auth' (авторизация карты)
  const authPayments = payments.filter(p => p.status === 'auth');
  console.log('usePendingPayments: найдено платежей auth:', authPayments.length);
  
  const latestAuthPayment = authPayments.length > 0 
    ? authPayments.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())[0]
    : null;
  
  // Логируем результат для отладки
  if (latestAuthPayment) {
    console.log('usePendingPayments: найден последний auth платеж:', latestAuthPayment.id);
  }
  
  // Сортируем платежи по дате (новые вверху)
  const sortedPendingPayments = pendingPayments.sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );
  
  return {
    pendingPayments: sortedPendingPayments,
    authPayment: latestAuthPayment
  };
};

export default usePendingPayments;
